import { render, staticRenderFns } from "./PurchaseGoods.vue?vue&type=template&id=d7789010&scoped=true&"
import script from "./PurchaseGoods.vue?vue&type=script&lang=js&"
export * from "./PurchaseGoods.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseGoods.vue?vue&type=style&index=0&id=d7789010&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7789010",
  null
  
)

export default component.exports